import type { LanguageType } from '../utils/types';

import {
  Bengali,
  Catalonia,
  Chinese,
  Denmark,
  English,
  Finland,
  French,
  German,
  Greece,
  Hungary,
  India,
  Indonesian,
  Italian,
  Japanese,
  Korea,
  Lithuania,
  Malay,
  Netherlands,
  Pakistan,
  Philippines,
  Poland,
  Portuguese,
  Russian,
  SaudiArabia,
  Serbia,
  Slovakia,
  SouthAfrica,
  Spanish,
  Swahili,
  Swedish,
  Thai,
  Turkish,
  Ukrainian,
  Vietnamese,
} from '@rango-dev/ui';

export const DEFAULT_LANGUAGE = 'en';
export const LOCALE_COOKIE = 'USER_LOCALE';
export const EXPIRATION_LOCALE_COOKIE_DAYS = 365; // 365 days

export const Languages: LanguageType[] = [
  { title: 'Afrikaans', englishTitle: 'Afrikaans', value: 'af', Icon: SouthAfrica },
  { title: 'عربي', englishTitle: 'Arabic', value: 'ar', Icon: SaudiArabia },
  { title: 'বাংলা', englishTitle: 'Bengali', value: 'bn', Icon: Bengali },
  { title: 'Català', englishTitle: 'Catalan', value: 'ca', Icon: Catalonia },
  { title: '简体中文', englishTitle: 'Chinese (Simplified)', value: 'zh-CN', Icon: Chinese },
  { title: '中文（繁體)', englishTitle: 'Chinese (Traditional)', value: 'zh-TW', Icon: Chinese },
  { title: 'Dansk', englishTitle: 'Danish', value: 'da', Icon: Denmark },
  { title: 'Nederlands', englishTitle: 'Dutch', value: 'nl', Icon: Netherlands },
  { title: 'English', englishTitle: 'English', value: 'en', Icon: English },
  { title: 'Filipino', englishTitle: 'Filipino', value: 'fil', Icon: Philippines },
  { title: 'Suomalainen', englishTitle: 'Finnish', value: 'fi', Icon: Finland },
  { title: 'Français', englishTitle: 'French', value: 'fr', Icon: French },
  { title: 'Deutsch', englishTitle: 'German', value: 'de', Icon: German },
  { title: 'ελληνικά', englishTitle: 'Greek', value: 'el', Icon: Greece },
  { title: 'हिंदी', englishTitle: 'Hindi', value: 'hi', Icon: India },
  { title: 'Magyar', englishTitle: 'Hungarian', value: 'hu', Icon: Hungary },
  { title: 'Indonesia', englishTitle: 'Indonesian', value: 'id', Icon: Indonesian },
  { title: 'Italiana', englishTitle: 'Italian', value: 'it', Icon: Italian },
  { title: '日本語', englishTitle: 'Japanese', value: 'ja', Icon: Japanese },
  { title: '한국인', englishTitle: 'Korean', value: 'ko', Icon: Korea },
  { title: 'Lietuvių', englishTitle: 'Lithuanian', value: 'lt', Icon: Lithuania },
  { title: 'Melayu', englishTitle: 'Malay', value: 'ms', Icon: Malay },
  { title: 'Polski', englishTitle: 'Polish', value: 'pl', Icon: Poland },
  { title: 'Português', englishTitle: 'Portuguese', value: 'pt', Icon: Portuguese },
  { title: 'Русский', englishTitle: 'Russian', value: 'ru', Icon: Russian },
  { title: 'Cрпски', englishTitle: 'Serbian', value: 'sr', Icon: Serbia },
  { title: 'Slovenský', englishTitle: 'Slovak', value: 'sk', Icon: Slovakia },
  { title: 'Español', englishTitle: 'Spanish', value: 'es', Icon: Spanish },
  { title: 'Kiswahili', englishTitle: 'Swahili', value: 'sw', Icon: Swahili },
  { title: 'Svenska', englishTitle: 'Swedish', value: 'sv', Icon: Swedish },
  { title: 'แบบไทย', englishTitle: 'Thai', value: 'th', Icon: Thai },
  { title: 'Türkçe', englishTitle: 'Turkish', value: 'tr', Icon: Turkish },
  { title: 'Yкраїні', englishTitle: 'Ukrainian', value: 'uk', Icon: Ukrainian },
  { title: 'اردو', englishTitle: 'Urdu', value: 'ur', Icon: Pakistan },
  { title: 'Tiếng Việt', englishTitle: 'Vietnamese', value: 'vi', Icon: Vietnamese },
];
